import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AA_TEXT_PRIMARY_ON_LIGHT, AA_DISABLED_BORDER } from '~/modules/Helper/contrast.helper';
import {
  PageTitle,
  Divider,
  List,
  Card,
  Col,
  Row,
  ButtonGoBack,
  Typography,
} from '~/components';
import { useMenus } from '~/contexts/menu.context';
import { TIPO_MENU_PORTAL } from '~/modules/Helper/tipoMenuPortal';
import * as ModuloService from '../../../services/modulos.service';
import { CHAVES_MODULO } from '../../Helper/chave-modulo-constants';

function transformarJson(menu) {
  if (!Array.isArray(menu)) {
    return [];
  }

  return menu.map(item => {
    const novosSubItens = [];
    const raizSubItens = Array.isArray(item.SubItens) ? item.SubItens : [];

    function extrairSubItens(subItens) {
      if (!Array.isArray(subItens)) {
        return;
      }

      subItens.forEach(subItem => {
        novosSubItens.push({ ...subItem, SubItens: [] });
        const filhos = Array.isArray(subItem.SubItens) ? subItem.SubItens : [];
        if (filhos.length > 0) {
          extrairSubItens(filhos);
        }
      });
    }

    extrairSubItens(raizSubItens);
    return { ...item, SubItens: novosSubItens };
  });
}

function Sumario() {
  const history = useHistory();
  const { menus } = useMenus();
  const [menusTransformados, setMenusTransformados] = useState([]);

  function handleRedirect(item) {
    if (!item.URI) return;
    if (item.TipoMenuPortal === TIPO_MENU_PORTAL.EXTERNO) {
      window.open(item.URI);
    } else {
      history.push(item.URI);
    }
  }

  useEffect(() => {
    ModuloService.verificaModuloHabilitado(CHAVES_MODULO.SUMARIO);
    setMenusTransformados(transformarJson(menus));
  }, [menus]);

  return (
    <>
      <PageTitle titulo="Sumário" />
      <Col>
        <Card>
          <List
            itemLayout="horizontal"
            dataSource={menusTransformados}
            renderItem={item => (
              <List.Item style={{ display: 'list-item', borderBottom: '0px' }}>
                <div style={{ width: '100%' }}>
                  <Typography.Title
                    level={2}
                    style={{
                      fontSize: 16,
                      lineHeight: 1.4,
                      margin: '0 0 8px',
                      fontWeight: 600,
                    }}
                  >
                    {item.URI ? (
                      <a
                        href={`#${item.URI.startsWith('/') ? item.URI : `/${item.URI}`}`}
                        onClick={event => {
                          event.preventDefault();
                          handleRedirect(item);
                        }}
                      >
                        {item.Titulo}
                      </a>
                    ) : (
                      item.Titulo
                    )}
                  </Typography.Title>
                  <Divider
                    style={{
                      margin: '0px',
                      borderTop: `1px solid ${AA_DISABLED_BORDER}`,
                      width: '95%',
                    }}
                  />
                  {Array.isArray(item.SubItens) && item.SubItens.length > 0 && (
                    <ul
                      style={{
                        listStyleType: 'none',
                        paddingInlineStart: '0px',
                      }}
                    >
                      {item.SubItens.map(sub => (
                        <li
                          key={sub.Id}
                          style={{ color: AA_TEXT_PRIMARY_ON_LIGHT }}
                        >
                          {sub.URI ? (
                            <a
                              href={`#${
                                sub.URI.startsWith('/') ? sub.URI : `/${sub.URI}`
                              }`}
                              onClick={event => {
                                event.preventDefault();
                                handleRedirect(sub);
                              }}
                            >
                              {sub.Titulo}
                            </a>
                          ) : (
                            <span>{sub.Titulo}</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </List.Item>
            )}
          />
        </Card>
      </Col>
      <Row>
        <ButtonGoBack />
      </Row>
    </>
  );
}

export default Sumario;
